import { render, staticRenderFns } from "./CallbackPage.vue?vue&type=template&id=0af71012"
import script from "./CallbackPage.vue?vue&type=script&lang=ts"
export * from "./CallbackPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports